import Redux from 'redux'
import * as Modal from '../../../components/modal'
import * as Constants from './constants'

export interface UpdateAttributeAction extends Redux.Action { index: number, field: Modal.ModalField }
export type UpdateAttributeFn = (index: number, field: Modal.ModalField) => UpdateAttributeAction
export const updateAttribute: UpdateAttributeFn = (index: number, field: Modal.ModalField) =>
  ({type: Constants.EDIT_MEMBER_DETAIL_ATTRIBUTE, index, field})

export interface EditAttributeAction extends Redux.Action { index: number }
export type EditAttributeFn = (index: number) => EditAttributeAction
export const editAttribute: EditAttributeFn = (index: number) =>
  ({type: Constants.CLICK_MEMBER_DETAIL_ATTRIBUTE, index})

export type AddAttributeAction = Redux.Action
export type AddAttributeFn = () => AddAttributeAction
export const addAttribute: AddAttributeFn = () =>
  ({type: Constants.ADD_MEMBER_DETAIL_ATTRIBUTE})



// WEBPACK FOOTER //
// ./src/pages/member-details/attributes/actions.ts